var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "item" },
    [
      _c(
        "w-link",
        {
          staticClass: "mr",
          class: { invisible: !_vm.hasChildren },
          attrs: { disabled: !_vm.hasChildren },
          on: {
            click: function ($event) {
              _vm.opened = !_vm.opened
            },
          },
        },
        [_c("w-fa", { attrs: { icon: _vm.openIcon } })],
        1
      ),
      _c(
        "w-link",
        {
          class: { selected: _vm.selected },
          on: {
            click: function ($event) {
              return _vm.itemClicked(_vm.value)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.value.Name) + " ")]
      ),
      _vm.opened
        ? _c(
            "div",
            { staticClass: "items ml" },
            _vm._l(_vm.value.Children, function (child) {
              return _c("app-product-group-select-node", {
                key: child.ID,
                attrs: {
                  value: child,
                  "use-ids": _vm.useIds,
                  "selected-value": _vm.selectedValue,
                },
                on: {
                  click: function ($event) {
                    return _vm.itemClicked($event)
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }